/**
 * HtmlStandard
 * @module components/HtmlStandard
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import style from './HtmlStandard.scss';

import { FavoritesProvider } from 'context/favorites.context';
import { I18nContext } from 'context/i18n.context';
import Header from 'components/Header';
import Footer from 'components/Footer';
import footerContent from './content/footer';


/** Class representing the component. */
class HtmlStandard extends Component {

	static contextType = I18nContext;

	componentDidUpdate() {
		// Update addthis sharing urls
		if (typeof addthis !== 'undefined') {			
			addthis.update('share', 'url', window.location.href);
			addthis.update('share', 'title', this.props.metatags && this.props.metatags.title ? this.props.metatags.title : this.props.title);
			addthis.ready();
		}
	}

	/**
	 * Renders OG embed images.
	 */
	 renderOgImage (images) {
		 let ogImages = [];

		 if (images.length > 0) {
			 ogImages = images.map((img) => {
				 return (<meta property="og:image" content={img} key={img} />);
			 });
			 ogImages.push(<meta name="twitter:image" content={images[0]} key={images[0] + '-twitter'} />);
		 } else {
			 ogImages = [
				 <meta name="twitter:image" content="/static/share.jpg" key="/static/share.jpg" />,
				 <meta property="og:image" content="/static/share.jpg" key="/static/share.jpg-twitter" />
			 ];
		 }

		 return ogImages;
	 }


	/**
	 * The render method
	 */
	render () {
		const { mainMenu, topMenu } = this.props.context;
		const { t, currentLanguage } = this.context;

		const originalMetatags = this.props.metatags || {};
		const metatags = {
			title: '',
			'og:description': '',
			'article:published_time': '',
			'article:modified_time': '',
			'og:site_name': '',
			'og:type': '',
			'og:title': '',
			'og:description': '',
			'og:url': '',
			'canonical': '',
			'shortlink': '',
			'og:image': [],
			...originalMetatags
		};

		return (
			<div>
				<Head>
					<script id="CookieConsent" src="https://policy.app.cookieinformation.com/uc.js" data-culture={currentLanguage.toUpperCase()} type="text/javascript"></script>
					<title>{ metatags.title || this.props.title || 'IndustriALL' }</title>
					<link rel="apple-touch-icon" sizes="57x57" href="/static/icons/apple-touch-icon-57x57.png" />
					<link rel="apple-touch-icon" sizes="60x60" href="/static/icons/apple-touch-icon-60x60.png" />
					<link rel="apple-touch-icon" sizes="72x72" href="/static/icons/apple-touch-icon-72x72.png" />
					<link rel="apple-touch-icon" sizes="76x76" href="/static/icons/apple-touch-icon-76x76.png" />
					<link rel="apple-touch-icon" sizes="114x114" href="/static/icons/apple-touch-icon-114x114.png" />
					<link rel="apple-touch-icon" sizes="120x120" href="/static/icons/apple-touch-icon-120x120.png" />
					<link rel="apple-touch-icon" sizes="144x144" href="/static/icons/apple-touch-icon-144x144.png" />
					<link rel="apple-touch-icon" sizes="152x152" href="/static/icons/apple-touch-icon-152x152.png" />
					<link rel="apple-touch-icon" sizes="180x180" href="/static/icons/apple-touch-icon-180x180.png" />
					<link rel="icon" type="image/png" href="/static/icons/favicon-32x32.png" sizes="32x32" />
					<link rel="icon" type="image/png" href="/static/icons/android-chrome-192x192.png" sizes="192x192" />
					<link rel="icon" type="image/png" href="/static/icons/favicon-96x96.png" sizes="96x96" />
					<link rel="icon" type="image/png" href="/static/icons/favicon-16x16.png" sizes="16x16" />
					<link rel="manifest" href="/static/icons/manifest.json" />
					<link rel="shortcut icon" href="/static/icons/favicon.ico" />

					<meta name="viewport" content="width=device-width, initial-scale=1.0" />

					<meta name="apple-mobile-web-app-title" content="IndustriALL" />
					<meta name="apple-mobile-web-app-status-bar-style" content="black" />
					<meta name="apple-mobile-web-app-capable" content="no" />
					<meta name="mobile-web-app-capable" content="no" />
					<meta name="msapplication-TileColor" content="#ffffff" />
					<meta name="msapplication-TileImage" content="/static/icons/mstile-144x144.png" />
					<meta name="msapplication-config" content="/static/icons/browserconfig.xml" />
					<meta name="theme-color" content="#ffffff" />

					<meta name="google-translate-customization" content="b8c0a63407c6e0b7-5a2099aec2ee2e5f-g54e3d1c2fbf70e12-19" />

					<meta name="twitter:card" content="summary_large_image" />
					<meta name="twitter:site" content="@IndustriALL_GU" />
					<meta name="twitter:creator" content="@IndustriALL_GU" />

					<meta name="description" content={metatags.description} />
					<meta name="twitter:description" content={metatags['og:description']} />
					<meta property="article:published_time" content={metatags['article:published_time']} />
					<meta property="article:modified_time" content={metatags['article:modified_time']} />
					<meta property="og:site_name" content={metatags['og:site_name']} />
					<meta property="og:type" content={metatags['og:type']} />
					<meta property="og:title" content={metatags['og:title']} />
					<meta name="twitter:title" content={metatags['og:title']} />
					<meta property="og:description" content={metatags['og:description'] || ''} />
					<meta property="og:url" content={metatags['og:url']} />

					<link rel="canonical" href={metatags.canonical} />

					{ this.renderOgImage(metatags['og:image']) }

					<script dangerouslySetInnerHTML={{
						__html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
						j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
						'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
						})(window,document,'script','dataLayer','GTM-MFW246');` }}>
					</script>
				</Head>
				<a href="#main-content" accessKey="s" className="is-visuallyhidden is-focusable">{t('jumpToMainContent')}</a>

				<FavoritesProvider>
					<Header mainMenu={mainMenu} topMenu={topMenu} />
					<main className={style.pageContent}>
						{this.props.children}
					</main>
				</FavoritesProvider>
				
				<Footer sections={footerContent[currentLanguage]} copyright='<p>© Copyright 2018 - IndustriALL - We care about your personal information and data. Take a look at our <a href="/information-about-cookies">Privacy Policy</a>.</p>' />

				<script type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>
				<script type="text/javascript" dangerouslySetInnerHTML={{ __html: `function googleTranslateElementInit() { new google.translate.TranslateElement({ pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE, autoDisplay: false, multilanguagePage: true, gaTrack: true, gaId: 'UA-32569520-1' }, 'google_translate_element'); }` }} />

				<script dangerouslySetInnerHTML={{ __html: `var addthis_config = { ui_language: '${currentLanguage}' }; var addthis_share = { title: '${metatags.title || this.props.title}' };` }}>	
				</script>
				{ currentLanguage === 'es' ? <script src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-56028d532599345f" async="async"></script> :
					currentLanguage === 'fr' ? <script src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-56028d693254e51f" async="async"></script> :
					currentLanguage === 'ru' ?  <script src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-58b9631575f7ecd4" async="async"></script> :
					<script src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-4fe039954eb5ce19" async="async"></script> }
			</div>
		);
	}
}


HtmlStandard.propTypes = {
	title: PropTypes.string,
	metatags: PropTypes.object
};


/** Export */
export default HtmlStandard;
